import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-mcommerce',
  templateUrl: './mcommerce.component.html',
  styleUrls: ['./mcommerce.component.scss']
})
export class McommerceComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
